import api from "../api/config";

export const locationService = {
  // Tüm şehirleri getir
  getCities: async () => {
    try {
      // console.log("LocationService: Şehirler getiriliyor...");
      const response = await api.get("/cities/list");
      // console.log("LocationService: Şehirler yanıtı:", response);

      // API interceptor zaten response.data döndürüyor
      return response || [];
    } catch (error) {
      console.error("LocationService Error fetching cities:", error);
      throw new Error("Şehirler getirilirken bir hata oluştu.");
    }
  },

  // Belirli bir şehrin ilçelerini getir
  getDistricts: async (cityId) => {
    try {
      // console.log(
      //   `LocationService: İlçeler getiriliyor (Şehir ID: ${cityId})...`
      // );
      const response = await api.get(`/districts/list`, {
        params: { cityId: cityId },
      });
      console.log("LocationService: İlçeler yanıtı:", response);

      // API interceptor zaten response.data döndürüyor
      return response || [];
    } catch (error) {
      console.error("LocationService Error fetching districts:", error);
      throw new Error("İlçeler getirilirken bir hata oluştu.");
    }
  },

  // Bayileri getir
  getDealers: async (cityId = null, districtId = null) => {
    try {
      const params = {};
      if (cityId) params.cityId = cityId;
      if (districtId) params.districtId = districtId;

      // console.log("LocationService: Bayiler getiriliyor...", params);
      const response = await api.get("/dealers/list", { params });
      // console.log("LocationService: Bayiler yanıtı:", response);

      // API interceptor zaten response.data döndürüyor
      return response || [];
    } catch (error) {
      console.error("LocationService Error fetching dealers:", error);
      throw new Error("Bayiler getirilirken bir hata oluştu.");
    }
  },

  // Kategorileri getir
  getCategories: async () => {
    try {
      // console.log("LocationService: Kategoriler getiriliyor...");
      const response = await api.get("/categories/list");
      // console.log("LocationService: Kategoriler yanıtı:", response);

      // API interceptor zaten response.data döndürüyor
      return response || [];
    } catch (error) {
      console.error("LocationService Error fetching categories:", error);
      throw new Error("Kategoriler getirilirken bir hata oluştu.");
    }
  },

  // Semtleri getir
  getSemts: async (districtId) => {
    try {
      console.log(
        `LocationService: Semtler getiriliyor (İlçe ID: ${districtId})...`
      );
      const response = await api.get(`/api/v3/semts/list`, {
        params: { districtId: districtId },
      });
      console.log("LocationService: Semtler yanıtı:", response);

      // API interceptor zaten response.data döndürüyor
      return response || [];
    } catch (error) {
      console.error("LocationService Error fetching semts:", error);
      throw new Error("Semtler getirilirken bir hata oluştu.");
    }
  },

  // Mahalleleri getir
  getNeighbourhoods: async (semtId) => {
    try {
      console.log(
        `LocationService: Mahalleler getiriliyor (Semt ID: ${semtId})...`
      );
      const response = await api.get(`/api/v3/mahalles/list`, {
        params: { semtId: semtId },
      });
      console.log("LocationService: Mahalleler yanıtı:", response);

      // API interceptor zaten response.data döndürüyor
      return response || [];
    } catch (error) {
      console.error("LocationService Error fetching neighbourhoods:", error);
      throw new Error("Mahalleler getirilirken bir hata oluştu.");
    }
  },
};

export default locationService;
